export default function () {
    return {
        restrict: 'E',
        replace: true,
        template: require('../partials-html/tabs-v1.html')
    };
}



// WEBPACK FOOTER //
// ./Client/app/sink/main/partials-js/tabsV1.js